import { Bot } from "lucide-react";
import { ChatbotWidgetInitResponse } from "../../services/chatbotWidget.service";

const TypingIndicator = ({ config }: { config: ChatbotWidgetInitResponse }) => {
  const primaryColor = config?.primaryColor || '#0f766e';

  return (
    <div className="flex justify-start mb-4">
      <div className="flex items-start">
        <div className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-2 overflow-hidden bg-gray-200">
          {config.logo ? (
            <img
              src={config.logo}
              alt="Bot logo"
              className="w-6 h-6 object-cover"
            />
          ) : (
            <Bot size={16} className="text-gray-600" />
          )}
        </div>
        <div className="rounded-xl rounded-tl-none px-4 py-3 bg-white border border-gray-100 shadow-sm" style={{ borderColor: `${primaryColor}20` }}>
          <div className="flex gap-1.5 items-center h-4">
            <div className="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
